import { api } from "@/store";
import { ListResponse } from "@/types/api";

export interface Office {
  id: number;
  name?: string;
  legal_name?: string;
  vat_number?: string;
  address?: Partial<Address>;
  phone?: string;
  email?: string;
}

export const fetchOffices = async (group_id: number) => {
  const response = await api.get<ListResponse<Office>>(`/groups/${group_id}/offices`, { withCredentials: true });
  return response.data;
};
